import { render, staticRenderFns } from "./CragRouteComments.vue?vue&type=template&id=334b4d0b"
import script from "./CragRouteComments.vue?vue&type=script&lang=js"
export * from "./CragRouteComments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports